<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import PrizeGoldImage from '@/assets/images/medal-gold.png'
import PrizeSilverImage from '@/assets/images/medal-silver.png'
import PrizeBronzeImage from '@/assets/images/medal-bronze.png'
import PrizeDefaultImage from '@/assets/images/medal-star.png'
import { twMerge } from 'tailwind-merge'

enum PrizeType {
  GOLD = 1,
  SILVER = 2,
  BRONZE = 3,
  DEFAULT = 4
}

const props = withDefaults(defineProps<{
  position: number
  showWinners?: boolean
  size?: 'md' | 'lg'
}>(), {
  size: 'md',
  showWinners: false,
})

const prizeType = ref<PrizeType>(PrizeType.GOLD)

const prizeImageMap = {
  [PrizeType.GOLD]: PrizeGoldImage,
  [PrizeType.SILVER]: PrizeSilverImage,
  [PrizeType.BRONZE]: PrizeBronzeImage,
  [PrizeType.DEFAULT]: PrizeDefaultImage,
}

const borderClassMap = {
  [PrizeType.GOLD]: 'gold-background',
  [PrizeType.SILVER]: 'bg-[#9D9D9D]',
  [PrizeType.BRONZE]: 'bg-[#923906]',
  [PrizeType.DEFAULT]: props.showWinners ? 'bg-transparent' : 'bg-[#727274]',
}

function getPrizeType() {
  switch (props.position) {
  case 1:
    return PrizeType.GOLD
  case  2:
    return PrizeType.SILVER
  case  3:
    return PrizeType.BRONZE
  default:
    return PrizeType.DEFAULT
  }
}

onBeforeMount(() => {
  prizeType.value = getPrizeType()
})
</script>
<template>
  <div
    :class="twMerge('rounded-full overflow-hidden flex items-center justify-center p-0.5',
                    size === 'md' ? 'size-[42px] min-w-[42px]' : 'size-[48px] min-w-[48px]', borderClassMap[prizeType])"
  >
    <div
      v-if="!showWinners || position <= 3"
      class="flex items-center justify-center bg-dark-top-layer rounded-full p-2"
    >
      <img
        :src="prizeImageMap[prizeType]"
        class="object-cover"
      >
    </div>
    <span
      v-else
      class="text-sm font-semibold"
    >
      {{ position }}.
    </span>
  </div>
</template>
<style scoped>
.gold-background {
  background: linear-gradient(#FFF246 0, #E5B80B 37%, #FFF571 69%, #E5B80B 100%);
}
</style>